// services/autoLogin.ts
// Guarda las credenciales encriptadas localmente para login silencioso
// cuando Firebase pierde la sesión (swipe en Android, etc.)

const KEY = 'tolkx_session';

// Encriptación simple con XOR — no es seguridad bancaria pero
// evita que las credenciales sean legibles a simple vista
const xor = (str: string, key: string): string => {
  return Array.from(str)
    .map((c, i) => String.fromCharCode(c.charCodeAt(0) ^ key.charCodeAt(i % key.length)))
    .join('');
};

const encode = (str: string): string => btoa(xor(str, 'tolkx_2024_key'));
const decode = (str: string): string => xor(atob(str), 'tolkx_2024_key');

export const saveSession = (email: string, password: string) => {
  try {
    const data = JSON.stringify({ email, password });
    localStorage.setItem(KEY, encode(data));
  } catch { /* ignore */ }
};

export const clearSession = () => {
  localStorage.removeItem(KEY);
};

export const getSavedSession = (): { email: string; password: string } | null => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const data = JSON.parse(decode(raw));
    if (!data.email || !data.password) return null;
    return data;
  } catch {
    return null;
  }
};